/* cs-variant-picker (snippets/cs-variant-picker.liquid), 5 October 2026.

   Swatches and pills on a product card. One delegated click listener for
   the page, so cards the theme editor re-renders still work. Each picker
   starts on the product's first available variant.

   Rules:
   - A colour swatch is always clickable. Picking one keeps the other
     choices where that variant exists, else moves to the first available
     variant in that colour.
   - A quantity or size pill that does not exist (or is sold out) with the
     current colour is greyed and cannot be clicked.
   - The card's photo and price follow the chosen variant.
   The card gets data-variant, data-price, data-available,
   data-variant-title and data-thumb, and a "cs-vp:change" event. */

(function () {
  'use strict';
  if (window.csVariantPickerReady) return;
  window.csVariantPickerReady = true;

  var fmt;
  try {
    fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
  } catch (e) {
    fmt = { format: function (n) { return '£' + n.toFixed(2); } };
  }
  function money(cents) {
    return fmt.format(cents / 100).replace(/\.00$/, '');
  }

  function readData(root) {
    if (root._vp) return root._vp;
    var el = root.querySelector('[data-cs-vp-data]');
    var data = { colourIndex: -1, variants: [] };
    try { data = JSON.parse(el.textContent); } catch (e) {}
    root._vp = data;
    return data;
  }

  /* The current choice, as { colour, qty, opts: { index: value } }. */
  function fromVariant(data, v) {
    var sel = { colour: v.colour, qty: v.qty, opts: {} };
    v.options.forEach(function (val, i) {
      if (i !== data.colourIndex) sel.opts[i] = val;
    });
    return sel;
  }

  function matches(data, v, sel, skip) {
    if (skip !== 'colour' && data.colourIndex >= 0 && v.colour !== sel.colour) return false;
    if (skip !== 'qty' && v.qty !== sel.qty) return false;
    for (var i in sel.opts) {
      if (skip === 'opt' + i) continue;
      if (v.options[i] !== sel.opts[i]) return false;
    }
    return true;
  }

  function find(data, sel) {
    for (var i = 0; i < data.variants.length; i++) {
      if (matches(data, data.variants[i], sel)) return data.variants[i];
    }
    return null;
  }

  function paint(root, variant) {
    var data = readData(root);
    var sel = root._sel;
    var card = root.closest('[data-cs-card]');

    Array.prototype.forEach.call(root.querySelectorAll('[data-cs-vp-colour]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cs-vp-colour') === sel.colour ? 'true' : 'false');
    });
    var name = root.querySelector('[data-cs-vp-colour-name]');
    if (name) name.textContent = sel.colour;

    /* Greyed when that value, with every other current choice, has no
       variant on sale. */
    function offered(test) {
      return data.variants.some(function (v) { return v.available && test(v); });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-cs-vp-qty]'), function (b) {
      var q = b.getAttribute('data-cs-vp-qty');
      var ok = offered(function (v) { return v.qty === q && matches(data, v, sel, 'qty'); });
      b.disabled = !ok;
      b.classList.toggle('is-off', !ok);
      b.setAttribute('aria-pressed', q === sel.qty ? 'true' : 'false');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-cs-vp-opt]'), function (b) {
      var i = b.getAttribute('data-cs-vp-opt');
      var val = b.getAttribute('data-value');
      var ok = offered(function (v) { return v.options[i] === val && matches(data, v, sel, 'opt' + i); });
      b.disabled = !ok;
      b.classList.toggle('is-off', !ok);
      b.setAttribute('aria-pressed', sel.opts[i] === val ? 'true' : 'false');
    });

    if (!card || !variant) return;
    card.setAttribute('data-variant', variant.id);
    card.setAttribute('data-price', variant.price);
    card.setAttribute('data-available', variant.available ? 'true' : 'false');
    card.setAttribute('data-variant-title', variant.title);
    if (variant.thumb) card.setAttribute('data-thumb', variant.thumb);

    var price = card.querySelector('[data-cs-card-price]');
    if (price) price.textContent = money(variant.price);

    var holder = card.querySelector('[data-cs-card-img]');
    var img = holder && (holder.tagName === 'IMG' ? holder : holder.querySelector('img'));
    if (img && variant.img && img.getAttribute('data-vp-src') !== variant.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = variant.img;
      img.setAttribute('data-vp-src', variant.img);
    }

    card.dispatchEvent(new CustomEvent('cs-vp:change', { bubbles: true, detail: { variant: variant } }));
  }

  function init(root) {
    if (root._sel) return;
    var data = readData(root);
    var first = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].available) { first = data.variants[i]; break; }
    }
    first = first || data.variants[0];
    if (!first) return;
    root._sel = fromVariant(data, first);
    paint(root, first);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cs-vp]'), init);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cs-vp-colour], [data-cs-vp-qty], [data-cs-vp-opt]') : null;
    if (!b || b.disabled) return;
    var root = b.closest('[data-cs-vp]');
    if (!root) return;
    init(root);
    var data = readData(root);
    var sel = root._sel;

    if (b.hasAttribute('data-cs-vp-colour')) {
      sel.colour = b.getAttribute('data-cs-vp-colour');
    } else if (b.hasAttribute('data-cs-vp-qty')) {
      sel.qty = b.getAttribute('data-cs-vp-qty');
    } else {
      sel.opts[b.getAttribute('data-cs-vp-opt')] = b.getAttribute('data-value');
    }

    var v = find(data, sel);
    if (!v || !v.available) {
      /* Keep the colour just picked, take the first available variant in
         it, and carry its other values over. */
      var key = b.hasAttribute('data-cs-vp-colour') ? 'colour' : null;
      var pool = data.variants.filter(function (x) {
        return x.available && (key ? x.colour === sel.colour : matches(data, x, sel, 'none'));
      });
      v = pool[0] || v;
      if (v) root._sel = sel = fromVariant(data, v);
    }
    paint(root, v);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.csVariantPicker = { init: initAll };
})();
